export const iconFontAwesomeEmojiFaceLaughSquint = (
	<i className="fa-solid fa-face-laugh-squint"></i>
);
